export const regExpEmail = (value) => /^([0-9a-zA-Z]([-._\w]*[0-9a-zA-Z])*@([0-9a-zA-Z][-\w]*[0-9a-zA-Z]\.)+[a-zA-Z]{2,9})$/.test(value);

export const regExpCodiceFiscaleOrPartitaIva = (value) => /^[0-9]{11}$|[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/.test(value);

export const regExpCodiceFiscalePNF = (value) => /^[0-9]{11}$/.test(value);

export const regExpCodiceFiscale = (value) => /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/.test(value);

export const regExpValidChars = (value) => /^[A-Za-z0-9\-_'àèìòùéÀÈÉÒÌÙ./,&amp;* ]{0,4000}$/.test(value);

export const regExpOnlyNumbers = (value) => /^[0-9]{0,4000}$/.test(value)

export const regExpDate = (value) => /^(0[1-9]|[12][0-9]|3[01])[/]{1}(0[1-9]|1[012])[/]{1}[0-9]{4}$/.test(value);

export const regExpIBAN = (value) => /^[a-zA-Z0-9]{27}$/.test(value);

export const regexLettereMaiuscoleMinuscoleNumeriSpazioUnderscoreTrattino = (value) => /^[A-Za-z0-9-_&amp; ]{0,40}$/.test(value);


export const regExpRepertorioRaccolta = (value) => /^([0-9]{1,7})(\/+([0-9]{1,5}))?$/.test(value) 